var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolar101 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 10.645
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.258,
    height: 7.516,
    x: 20.371,
    y: 0.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.933 6.07c-.61-.61-1.6-.61-2.21 0l-3.105 3.105c-.61.61-.61 1.6 0 2.21l.095.094c.61.61 1.599.61 2.21 0l3.104-3.105c.61-.61.61-1.6 0-2.21l-.094-.094zM43.5 21.933c0-.862-.7-1.562-1.563-1.562h-4.39c-.864 0-1.563.7-1.563 1.562v.134c0 .862.7 1.562 1.562 1.562h4.392c.862 0 1.562-.7 1.562-1.562v-.134zM37.027 36.933c.61-.61.61-1.6 0-2.21l-3.105-3.105c-.61-.61-1.6-.61-2.21 0l-.094.095c-.61.61-.61 1.599 0 2.21l3.105 3.104c.61.61 1.6.61 2.21 0l.094-.094z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.258,
    height: 7.516,
    x: 20.371,
    y: 35.984,
    rx: 1.5,
    transform: "rotate(-180 22 39.742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.164 37.027c.61.61 1.6.61 2.21 0l3.105-3.105c.61-.61.61-1.6 0-2.21l-.094-.094c-.61-.61-1.6-.61-2.21 0L6.07 34.723c-.61.61-.61 1.6 0 2.21l.094.094zM.5 22.067c0 .862.7 1.562 1.563 1.562h4.39c.864 0 1.563-.7 1.563-1.562v-.134c0-.862-.7-1.562-1.562-1.562H2.063c-.863 0-1.563.7-1.563 1.562v.134zM6.07 6.164c-.61.61-.61 1.6 0 2.21l3.105 3.105c.61.61 1.6.61 2.21 0l.094-.094c.61-.61.61-1.6 0-2.21L8.374 6.07c-.61-.61-1.6-.61-2.21 0l-.094.094z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolar101);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/solar-101.61979a36abfbdef880a2979a214738bd.svg";